class RequestChangeStatusModel {
    id: number;
    flowId: number;
    flowTitle: string;
    radParentPeygirId: string;
    radPeygirId: string;
    radFlowId: number;
    radFirstWorkTypeId: number;
    radWorkTypeId: number;
    requestId: number;
    flowSettingId: number;
    flowSettingTitle: string;
    flowSettingResultId: number;
    flowSettingResultTitle: string;
    radFlowResultId: number;
    fileAttachedId: number;
    description: string;
    attachRequired: boolean;
    codeRequired: boolean;
    isActive: boolean;

    constructor(
        id: number,
        flowId: number,
        flowTitle: string,
        radParentPeygirId: string,
        radPeygirId: string,
        radFlowId: number,
    radFirstWorkTypeId: number,
        radWorkTypeId: number,
        requestId: number,
        flowSettingId: number,
        flowSettingTitle: string,
        flowSettingResultId: number,
        flowSettingResultTitle: string,
        radFlowResultId: number,
        fileAttachedId: number,
        description: string,
        attachRequired: boolean,
        codeRequired: boolean,
        isActive: boolean,
    ) {
        this.id = id;
        this.flowId = flowId;
        this.flowTitle = flowTitle;
        this.radParentPeygirId = radParentPeygirId;
        this.radPeygirId = radPeygirId;
        this.radFlowId = radFlowId;
        this.radFirstWorkTypeId = radFirstWorkTypeId;
        this.radWorkTypeId = radWorkTypeId;
        this.requestId = requestId;
        this.flowSettingId = flowSettingId;
        this.flowSettingTitle = flowSettingTitle;
        this.flowSettingResultId = flowSettingResultId;
        this.flowSettingResultTitle = flowSettingResultTitle;
        this.radFlowResultId = radFlowResultId;
        this.fileAttachedId = fileAttachedId;
        this.description = description;
        this.attachRequired = attachRequired;
        this.codeRequired = codeRequired;
        this.isActive = isActive;
    }

    public static fromJson(json: any): RequestChangeStatusModel {
        return new RequestChangeStatusModel(
            json["id"],
            json["flowId"],
            json["flowTitle"],
            json["radParentPeygirId"],
            json["radPeygirId"],
            json["radFlowId"],
            json["radFirstWorkTypeId"],
            json["radWorkTypeId"],
            json["requestId"],
            json["flowSettingId"],
            json["flowSettingTitle"],
            json["flowSettingResultId"],
            json["flowSettingResultTitle"],
            json["radFlowResultId"],
            json["fileAttachedId"],
            json["description"],
            json["attachRequired"],
            json["codeRequired"],
            json["isActive"],
        );
    }
}


export interface RequestChangeStatusGetPayloadFilterModel {
    id?: number;
    flowSettingResulTitle?: string;
    flowTitle?: string;
    flowSettingTitle?: string;
    requestId?: number;
    flowSettingId?: number;
    flowSettingResultId?: number;
    createById?: number;
    flowId?: number;
    radParentPeygirId?: string;
    radPeygirId?: string;
    isActive?: number;
}

export interface RequestChangeStatusGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: RequestChangeStatusGetPayloadFilterModel;
}


export interface RequestChangeStatusPayloadModel {
    id: number;
    RequestId: number;
    FlowSettingId: number;
    RadPeygirId: string;
    FlowSettingResultId: number;
    Description: string;
    isActive: boolean;
   

}
export default RequestChangeStatusModel;
